// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1q0cJ","col":"styles_col__3VyPj","fulfillmentStatus":"styles_fulfillmentStatus__2lC_P","emailCol":"styles_emailCol__2jF5a"};